module.exports = __webpack_public_path__ + "img/circle-checkmark.dd3c6da0.svg";